// extracted by mini-css-extract-plugin
export default {"marketchart_d":"MarketChart_marketchart_d__REgPE","marketchart_l":"MarketChart_marketchart_l__7bTap","chart":"MarketChart_chart__uY0V1"};